<div class="dashboard-content-sec ">
    <div class="loader" *ngIf="showloader">
        <img src="assets/images/loader.gif" alt="">
    </div>

    <form (ngSubmit)="savePartner()" [formGroup]="form">
        <div class="row form-section">
            <div class="col">
                <div class="card">
                    <app-breadcrumb [crumbList]="crumbList"></app-breadcrumb>
                    <div class="card-title">
                        <h5 class='fa fa-address-book'>
                          {{ this.title }}
                        </h5>

                        <div class="float-right">
                            <button type="submit" class="btn btn-default align-items-end" tabindex="8">Submit</button>
                        </div>
                    </div>

                    <div class="card-form">
                        <div *ngIf="submitted && this.form.invalid" class="invalid-feedback">
                            <span >Please review for the form for invalid fields</span>
                        </div>

                        <div *ngIf="this.successful_result"
                            class="alert alert-success" role="alert">
                            Successfully saved record
                        </div>
                        <div *ngIf="this.error_result" class="alert alert-danger" role="alert">
                            Unable to save record. Error occurred.
                        </div>
    
                        <div class="form-row">
                            <label class="col-sm-2 control-label">Active</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleChange($event)" [checked]="status == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-2" id="statusLabel">{{status}}</label> 
                            </div>
                        </div>
   
                        <div class="form-row">
                            <label class="col-sm-2 control-label" for="CompanyName">Partner Company Name</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="CompanyName"  id="CompanyName"
                                    name="CompanyName" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="1" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="CompanyNameCtrl.invalid && (CompanyNameCtrl.dirty || CompanyNameCtrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="CompanyNameCtrl.errors.required">
                              <span>Client Name is required.</span>
                           </div>
                           <div *ngIf="CompanyNameCtrl.errors.minlength">
                              Client Name must be at least 2 characters long.
                           </div>
                        </div>

                        <div class="form-row" *ngIf="!isPartner">
                            <label class="col-sm-2 control-label">Is a Platform Partner</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="togglePlatform($event)" 
                                        [checked]="platform == 'Yes'"
                                        [disabled]="isPartner" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-2" id="platformLabel">{{platform}}</label> 
                            </div>
                        </div>
    
                        <div [ngClass]="{ collapse: this.platform == 'Yes' }" class="form-row" 
                            id="platformPartnerDiv" *ngIf="!isPartner">
                            <label class="col-sm-2">Platform Partner</label>
                            <div class="col-sm-4 form-group">
                                <select formControlName="PlatformPartnerID" name="PlatformPartnerID" 
                                    class="form-control" 
                                    [ngClass]="{ 'is-invalid': submitted && f.clientId.errors }">
                                    <option id="{{partner.ID}}" value="{{partner.ID}}" 
                                        *ngFor="let partner of platPartners">{{partner.CompanyName}}
                                    </option>
                                </select>
                            </div>
                        </div>


                        <div class="form-row">
                            <label class="col-sm-2" for="ContactName">Contact Name</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="ContactName"  id="ContactName"
                                name="ContactName" type="text" 
                                required 
                                class="form-control" 
                                tabindex="2" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="ContactNameCtrl.invalid && (ContactNameCtrl.dirty || ContactNameCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="ContactNameCtrl.errors.required">
                                <span>Contact Name is required.</span>
                            </div>
                        </div>


                        <div class="form-row">
                            <label class="col-sm-2" for="BillingName">Billing Name</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="BillingName"  id="BillingName"
                                name="BillingName" type="text" 
                                required 
                                class="form-control" 
                                tabindex="2" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="BillingNameCtrl.invalid && (BillingNameCtrl.dirty || BillingNameCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="BillingNameCtrl.errors.required">
                                <span>Billing Name is required.</span>
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2" for="BillingEmail">Billing Email</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="BillingEmail"  id="BillingEmail"
                                name="BillingEmail" type="text" 
                                required 
                                class="form-control" 
                                tabindex="2" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="BillingEmailCtrl.invalid && (BillingEmailCtrl.dirty || BillingEmailCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="BillingEmailCtrl.errors.required">
                                <span>Billing Email is required.</span>
                            </div>
                        </div>
            
                        <div class="form-row">
                            <label class="col-sm-2" for="Phone">Phone Number</label>                                    
                            <div class="form-group col-sm-4">
                                <input formControlName="Phone"  id="Phone"
                                    name="Phone" type="text" 
                                    required 
                                    class="form-control" 
                                    tabindex="3" placeholder="">
                            </div>
                        </div>    
                        <div *ngIf="PhoneCtrl.invalid && (PhoneCtrl.dirty || PhoneCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="PhoneCtrl.errors.required">
                                <span>Phone is required.</span>
                            </div>
                        </div>
                            

                        <div class="form-row">
                            <label class="col-sm-2" for="Address1">Address line 1</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="Address1" type="text" 
                                    class="form-control" id="Address1" tabindex="4" placeholder="">
                            </div>
                        </div>
                        <div *ngIf="Address1Ctrl.invalid && (Address1Ctrl.dirty || Address1Ctrl.touched)"
                            class="invalid-feedback">
                           <div *ngIf="Address1Ctrl.errors.required">
                              <span>Address is required.</span>
                           </div>
                           <div *ngIf="Address1Ctrl.errors.minlength">
                            Address must be at least 2 characters long.
                           </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2" for="Address2">Address line 2</label>
                            <div class="form-group col-sm-4">
                                <input formControlName="Address2" type="text" 
                                   class="form-control" id="Address2" tabindex="5" placeholder="">
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2" for="City">City</label>
                            <div class="form-group col-sm-4">
                                    <input formControlName="City"  id="City"
                                    name="City" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="6" placeholder="">
                            </div>
                        </div>   
                        <div *ngIf="CityCtrl.invalid && (CityCtrl.dirty || CityCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="CityCtrl.errors.required">
                                <span>City is required.</span>
                            </div>
                        </div>

                        <div class="form-row">
                            <label class="col-sm-2" for="State">State</label>
                            <div class="col-sm-1">
                                    <input formControlName="State"  id="State"
                                    name="State" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="7" placeholder="">
                            </div>
                            <div *ngIf="StateCtrl.invalid && (StateCtrl.dirty || StateCtrl.touched)"
                                class="invalid-feedback">
                                <div *ngIf="StateCtrl.errors.required">
                                    <span>State is required.</span>
                                </div>
                            </div>


                            <div class="col-sm-1">&nbsp;</div>
                            <label class="col-sm-1" for="Zip">Zip</label>
                            <div class="form-group col-sm-1">
                                <input formControlName="Zip"  id="Zip"
                                    name="Zip" type="text" 
                                    required minlength="2"
                                    class="form-control" 
                                    tabindex="8" placeholder="">
                            </div>
                        </div>   
                        <div *ngIf="ZipCtrl.invalid && (ZipCtrl.dirty || ZipCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="ZipCtrl.errors.required">
                                <span>Zip is required.</span>
                            </div>
                        </div>                        

                        <div class="form-row">
                            <label class="col-sm-2" for="Notes">Notes</label>
                            <div class="form-group col-sm-8">
                                <textarea formControlName="Notes" type="text" rows="4"
                                    class="form-control" id="Notes" tabindex="9" placeholder="">
                                </textarea>                                
                            </div>
                        </div>
                        <div *ngIf="NotesCtrl.invalid && (NotesCtrl.dirty || NotesCtrl.touched)"
                            class="invalid-feedback">
                            <div *ngIf="NotesCtrl.errors.required">
                                <span>Notes is required.</span>
                            </div>
                        </div>

                        <div class="form-row mt-3" *ngIf="!isPartner">
                            <div style="border-top: 2px; border-color: #ebebeb; border-top-style: solid; width: 100%"></div>
                            <label class="mt-1 col-sm-4" style="text-align: center; font-weight: bold;">
                                Administrator Only Settings
                            </label>
                        </div>
                        <div class="form-row" *ngIf="!isPartner">
                            <label class="col-sm-2 control-label">Show Erisa Center</label>
                            <div class="form-group col-sm-4">
                                <label class="switch">
                                    <input type="checkbox" (change)="toggleErisa($event)" [checked]="erisa == 'Yes'" >
                                    <span class="slider"></span>
                                </label>
                                <label class="col-sm-2" id="statusLabel">{{erisa}}</label> 
                            </div>
                        </div>                        

                        <div class="form-row" *ngIf="!isPartner">
                            <label class="col-sm-2">Service Solicitation</label>
                            <div class="form-group col-sm-8">
                                <textarea formControlName="ServiceSolicitation" type="text" rows="4"
                                    class="form-control" id="ServiceSolicitation" tabindex="9" placeholder="">
                                </textarea>                                
                            </div>
                        </div>
                        

                    </div>
                </div>
            </div>
        </div>
    </form>
</div>

<div class="dashboard-content-sec mt-4" *ngIf="!isPartner">
    <div class="card mb-0">
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <a data-toggle="collapse" style="width:180px" class="p-2 fa fa-expand-alt" 
                href="#toolsDiv" (click)="swapIcon($event)">
                {{toolsList?.length}} Tools On Dashboard</a>
            </div>
            <div style='width: 140px' class="d-inline-block">
                    <a data-toggle="collapse" href="#newToolRow" 
                       class="fa fa-address-book btn btn-default "
                       (click)="expandTable('toolsDiv')">
                        Add Tool
                    </a>                        
            </div>       
            <b>Administrator can only see this. Leave blank for default list of tools</b>

        </div>

        <div id="toolsDiv" class="table-responsive collapse">
            <table id="toolsTable" class="table user-table table-striped">
                <thead>
                    <tr>
                        <th >Tool</th>
                        <th >Remove</th >
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let tool of toolsList">
                        <tr id="tool-row{{tool.ID}}">
                            <td>
                                <span>{{tool.Title}}</span>
                                <input id="tool{{tool.ID}}" value="{{tool.Title}}" hidden>
                            </td>
                   
                            <td>&nbsp;</td>
                            <td>
                                <div class="d-inline-block">
                                    <a id="del-tool{{tool.ID}}" title="Remove" class="btn fa fa-times"
                                    (click)="deleteTool(tool.ID)"> </a>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    
                    <tr class="collapse" id="newToolRow">
                        <td >
                            <select id="newTool"
                            class="custom-select new-state" style="width: 200px">
                                <option value="{{mTool.ID}}" 
                                    *ngFor="let mTool of masterToolsList">{{mTool?.Title}}
                                </option>
                            </select>
                        </td>
                        <td>
                            <div style='width: 140px' class="d-inline-block">
                                    <a class="fa btn btn-default "
                                        (click)="saveTool()">
                                        Save Tool
                                    </a>                        
                            </div>       
                        </td>
                        <td>
                            <div class="d-inline-block">
                                <a title="Cancel" class="btn fa fa-times" (click)="clearTool()"> </a>
                            </div>
                        </td>

                    </tr>
                </tbody>
            </table>

        </div>
    </div>
</div>




<div class="dashboard-content-sec mt-4">
    <div class="card mb-0">
        <div class="user-heading-sec">
            <div class="mr-4 d-inline-block">
                <a data-toggle="collapse" style="width:180px" class="p-2 fa fa-expand-alt" 
                href="#servicesDiv" (click)="swapIcon($event)">
                {{partnerServices?.length}} Services Offered</a>

            </div>
            <div style='width: 140px' class="d-inline-block">
                    <a data-toggle="collapse" href="#newServiceRow" 
                       class="fa fa-address-book btn btn-default "
                       (click)="expandTable('servicesDiv')">
                        Add Service
                    </a>                        
            </div>       
        </div>

        <div id="servicesDiv" class="table-responsive collapse">
            <table id="servicesTable" class="table user-table table-striped">
                <thead>
                    <tr>
                        <th >Service</th>
                        <th >Description</th>
                        <th >Remove</th >
                    </tr>
                </thead>

                <tbody>
                    <ng-container *ngFor="let ser of partnerServices">
                        <tr id="service-row{{ser.ID}}">
                            <td>
                                <span>{{ser.Code}}</span>
                                <input id="service{{ser.ID}}" value="{{ser.Code}}" hidden>
                            </td>
                   
                            <td>
                                <span>{{ser.Value}}</span>
                            </td>
                            <td>
                                <div class="d-inline-block">
                                    <a id="del-service{{ser.ID}}" title="Remove" class="btn fa fa-times"
                                    (click)="deleteService(ser.ID)"> </a>
                                </div>
                            </td>
                        </tr>
                    </ng-container>
                    
                    <tr class="collapse" id="newServiceRow">
                        <td >
                            <select id="newService"
                            class="custom-select new-state" style="width: 200px">
                                <option value="{{serv.ID}}" 
                                    *ngFor="let serv of masterServiceList">{{serv?.Code}}
                                </option>
                            </select>
                        </td>
                        <td>
                            <div style='width: 140px' class="d-inline-block">
                                    <a class="fa btn btn-default "
                                        (click)="saveService()">
                                        Save Service
                                    </a>                        
                            </div>       
                        </td>
                        <td>
                            <div class="d-inline-block">
                                <a title="Cancel" class="btn fa fa-times" (click)="clearService()"> </a>
                            </div>
                        </td>

                    </tr>
                </tbody>
                <ng-container *ngIf="clientStates?.length == 0">
                    <tr><td colspan="3">No Result Found</td></tr>
                </ng-container>                                 
            </table>

        </div>
    </div>
</div>



<div *ngIf="this.id > 0" class="mt-4">
    <app-user-list [partner_id]="this.id"></app-user-list>
</div>

<div *ngIf="this.id > 0" class="mt-4">
    <app-roleprofile-list [partner_id]="this.id" (submitted)="savePartner(true)"></app-roleprofile-list>
</div>

<div *ngIf="this.id > 0" class="mt-4">
    <app-authkey-list [partner_id]="this.id" (submitted)="savePartner(true)"></app-authkey-list>
</div>

